import React, { PureComponent, ReactNode } from "react";

import SortableTable from "react-sort-search-table";
import withServices from "../../HOCs/withServices";

import { TableControls } from "./PaginationTable.styles";

interface Props {
  tableData: any;
  tableHead?: any;
  dataKeys?: any;
  customTd?: any;
  apiCall?: any;
  pageCount: number;
  services?: any;
}
interface State {
  page: number;
  pageSize: number;
  searchString: string;
  searchUsers: [];
}

class PaginationTable extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      page: 1,
      pageSize: 10,
      searchString: "",
      searchUsers: [],
    };

    this.onSearchChange = this.onSearchChange.bind(this);
  }

  public fetchNextPage = (page, pageSize) => {
    this.props.apiCall(page, pageSize);
  };

//   public async searchUsers(searchString) {
//     const {
//       services: { institutionsAPI, currentUserID },
//     } = this.props;
//     const res = await institutionsAPI.userGlobalSearch(
//       currentUserID,
//       "students",
//       searchString
//     );
//     console.log({ res });
//     this.setState({ searchUsers: res.data.users });
//   }

  public onNavigationChange = (type, e) => {
    const { pageSize, page } = this.state;
    let currPage = page;
    let curPageSize = pageSize;

    if (type === "prev") {
      if (page === 1) {
        return;
      }
      currPage -= 1;
    }
    if (type === "next") {
      if (page === this.props.pageCount) {
        return;
      }
      currPage += 1;
    }

    if (type === "page") {
      currPage = +e.target.value;
    }

    if (type === "pagesize") {
      curPageSize = +e.target.value;
    }
    this.setState({
      page: currPage,
      pageSize: curPageSize,
    });
    this.fetchNextPage(currPage, curPageSize);
  };

  public async onSearchChange(e) {
    const searchString = e.target.value;
    if (!searchString.length || searchString === " ") {
      this.setState({ searchString: "", searchUsers: [] });
      return;
    }
    const {
      services: { institutionsAPI, currentUserID },
    } = this.props;
    const res = await institutionsAPI.userGlobalSearch(
      currentUserID,
      "students",
      searchString
    );
    this.setState({ searchUsers: res.data.users, searchString });
  }

  public render(): ReactNode {
    const { page, searchUsers, searchString } = this.state;
    const pages = new Array();

    for (let i = 1; i <= this.props.pageCount; i++) {
      pages.push(
        <option selected={page === i} value={i} key={`page-${i}`}>
          {i}
        </option>
      );
    }

    return (
      <div>
        <TableControls className="pager-wrapper">
          <div style={{visibility: searchString.length > 1 ? 'hidden' : 'visible' }} className="pagination">
            <button
              onClick={this.onNavigationChange.bind(this, "prev")}
              className="blue-button page-btn"
            >
              Previous
            </button>
            <select
              onChange={this.onNavigationChange.bind(this, "page")}
              name="page"
              id=""
              className="custom-select"
            >
              {pages}
            </select>
            <button
              onClick={this.onNavigationChange.bind(this, "next")}
              className="blue-button page-btn"
            >
              Next
            </button>

            <span>Display</span>
            <select
              onChange={this.onNavigationChange.bind(this, "pagesize")}
              name="pageSize"
              id="page-size"
              className="custom-select"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="75">75</option>
              <option value="100">100</option>
            </select>
            <span>Rows Per Page</span>
          </div>
          <div style={{ display: "flex", flexDirection: "column"}} className="search">
            <input
              style={{ width: "300px" }}
              onChange={this.onSearchChange}
              type="text"
              className="custom-textfield"
              placeholder="Search"
            />

            {!searchUsers.length && searchString.length ? (<p style={{color: "var(--red)"}}>No Match</p>) : ''}
            
          </div>
        </TableControls>
        <SortableTable
          tblData={searchUsers.length ? searchUsers : this.props.tableData}
          tHead={this.props.tableHead}
          dKey={this.props.dataKeys}
          customTd={this.props.customTd}
          paging={false}
          search={false}
          defaultCSS={false}
        />
      </div>
    );
  }
}

export default PaginationTable;



// WEBPACK FOOTER //
// ./src/components/PaginationTable/PaginationTable.Component.tsx